import { UserCircleIcon } from '@heroicons/react/solid'
import { useAuth } from 'src/auth'
import { Button } from '../Form'
import { ErrorTemplate } from './Template'

export function ErrorNotLoggedIn() {
  const { login, isLoading } = useAuth()

  return (
    <ErrorTemplate
      title="Not logged in"
      message="You need to be logged in to view this page"
      button={
        <Button
          label="login"
          onClick={login}
          icon={<UserCircleIcon />}
          iconPosition="left"
          isLoading={isLoading}
        />
      }
    />
  )
}
